import { successMessage } from 'hooks/helpers';
import api from './api';

class ImportSpreadsheetDataService {
  constructor() {
    this.httpClient = api;
  }

  async importData(payload, baseUrl, mappedJsonData) {
    try {
      const jsonData = mappedJsonData(payload);
      const { status, data } = await this.httpClient.post(`${baseUrl}/import`, jsonData);

      const { importedData, errors } = data;

      return {
        status,
        importedData,
        errorsData: errors,
        successMessage: successMessage(importedData.length, jsonData.length),
      };
    } catch (err) {
      const errorMessage = err.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new ImportSpreadsheetDataService();
